(function() {
  'use strict';
  var GCLID_COOKIE = '_bartact_gclid';
  var UTM_COOKIE   = '_bartact_utm';
  var COOKIE_DAYS  = 30;

  function getParam(name) {
    var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + encodeURIComponent(value) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  // Capture gclid
  var gclid = getParam('gclid');
  if (gclid) {
    setCookie(GCLID_COOKIE, gclid, COOKIE_DAYS);
    try {
      localStorage.setItem('_bartact_gclid_data', JSON.stringify({
        gclid: gclid,
        landingPage: window.location.pathname,
        timestamp: new Date().toISOString()
      }));
    } catch(e) {}
  }

  // Capture UTM params
  var utmParams = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term'];
  var utmData = {};
  var hasUtm = false;
  utmParams.forEach(function(p) {
    var v = getParam(p);
    if (v) { utmData[p] = v; hasUtm = true; }
  });
  if (hasUtm) {
    utmData.landingPage = window.location.pathname;
    utmData.timestamp = new Date().toISOString();
    setCookie(UTM_COOKIE, JSON.stringify(utmData), COOKIE_DAYS);
    try { localStorage.setItem('_bartact_utm_data', JSON.stringify(utmData)); } catch(e) {}
  }

  // Write everything to cart attributes
  var storedGclid = getCookie(GCLID_COOKIE);
  var storedUtmRaw = getCookie(UTM_COOKIE);
  var storedUtm = {};
  try { if (storedUtmRaw) storedUtm = JSON.parse(storedUtmRaw); } catch(e) {}

  var attrs = {};
  if (storedGclid) attrs['gclid'] = storedGclid;
  if (storedUtm.utm_source)   attrs['utm_source']   = storedUtm.utm_source;
  if (storedUtm.utm_medium)   attrs['utm_medium']   = storedUtm.utm_medium;
  if (storedUtm.utm_campaign) attrs['utm_campaign'] = storedUtm.utm_campaign;
  if (storedUtm.utm_content)  attrs['utm_content']  = storedUtm.utm_content;
  if (storedUtm.utm_term)     attrs['utm_term']     = storedUtm.utm_term;

  if (Object.keys(attrs).length > 0) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).catch(function() {});
  }
})();